<template>
    <div class="APP_bannerInfo">
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <el-card shadow="hover" style="min-width:500px">
            <el-form :model="infoForm" class="demo-form-inline" label-position="top">
                <el-form-item label="轮播图标题：">
                    <el-input clearable v-model="infoForm.title" placeholder="请输入协议标题"></el-input>
                </el-form-item>
                <el-form-item label="轮播图：">
                    <el-upload
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                    >
                        <div slot="tip" class="el-upload__tip">
                            <span>支持JPG、PNG格式，建议尺寸：670x236</span>
                        </div>
                        <img v-if="imgPath" :src="imgPath" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="排序：">
                    <el-input clearable v-model="infoForm.sort" placeholder="整数数字"></el-input>
                    <span style="font-size:12px;color:#606266">数字越小，显示顺序越靠前，请输入0-99的整数</span>
                </el-form-item>
                <el-form-item label="内容类型：">
                    <el-radio v-model="infoForm.type" :label="1" @change="handleRadioChange">自定义</el-radio>
                    <el-radio v-model="infoForm.type" :label="2" @change="handleRadioChange">链接</el-radio>
                    <!-- <el-radio v-model="infoForm.type" :label="3">内部链接</el-radio> -->
                    <el-radio v-model="infoForm.type" :label="0" @change="handleRadioChange">无</el-radio>
                </el-form-item>
                <el-form-item v-if="infoForm.type == 2">
                    <el-input
                        clearable
                        v-model="infoForm.path"
                        placeholder="请输入链接地址，类似于http://或https//"
                    ></el-input>
                </el-form-item>
            </el-form>
            <tinymce
                ref="editor"
                :value="infoForm.path"
                @getVal="getVal"
                v-if="infoForm.type == 1"
            />
            <div style="margin-top:15px;">
                <el-button type="primary" @click="submit" :loading="loading">保&nbsp;存</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import tinymce from '../../../components/Editor/Editor';
export default {
    name: "APP_bannerInfo",
    data() {
        return {
            uploadUrl: '',
            type: null, //0.添加 1.编辑
            imgPath: '',
            infoForm: {
                title: '', //标题
                image: '', //图片地址
                sort: '',//排序
                type: 0, //内容类型
                path: '', //内容
            },
            loading: false //按钮loading
        }
    },
    components: {
        tinymce
    },
    mounted() {
        this.uploadUrl = this.$api.uploadUrl;//上传文件地址
        let { type, id } = this.$route.query;
        this.type = type;
        if (type == 1) { //编辑
            this.$api.post('banner/getInfo', { id }, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.infoForm = data;
                    this.imgPath = data.image_path;
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    },
    methods: {
        submit() {
            this.loading = true;
            let reqData = this.type == 1 ? this._.pick(this.infoForm, ['id', 'title', 'image', 'sort', 'path', 'type']) : this.infoForm;
            this.$api.post('banner/save', reqData, res => {
                if (res.code == 0) {
                    let that = this;
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 1000,
                        onClose() {
                            that.$router.push('/banner');
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                    this.loading = false;
                }
            })
        },
        handleAvatarSuccess(res) { //logo
            if (res.code === 0) {
                this.imgPath = res.data.file_url; //请求路径
                this.infoForm.image = res.data.file_path //展示路径
            } else {
                //错误提示
                this.$message.error(res.msg);
            }
        },
        handleRadioChange() { //监听radio
            this.infoForm.path = "";
        },
        getVal(val) { //富文本的值
            this.infoForm.path = val;
        }
    }
}
</script>

<style scoped lang="scss">
.APP_bannerInfo {
    ::v-deep .el-form-item__label {
        line-height: 20px;
    }
    .el-form {
        max-width: 500px;
    }
    ::v-deep .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        background-color: #fdfdfd;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 40px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
    .avatar {
        width: 200px;
        height: 200px;
        display: block;
    }
}
</style>
